import * as Yup from 'yup';

export const PurchaseInfoSchema = Yup.object().shape({
  quality: Yup.string().required('عنوان  اجباری می باشد'),
  wanted_unit: Yup.string().required('عنوان  اجباری می باشد'),
  wanted: Yup.number().required('عنوان  اجباری می باشد'),
});
